import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  pure: false // important so UI updates automatically
})
export class TimeAgoPipe implements PipeTransform {

  transform(value: Date | string | null): string {
    if (!value) return '';

    const date = new Date(value);
    const now = new Date();

    const diffMs = now.getTime() - date.getTime();
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);

    if (diffSec < 60) return 'just now';
    if (diffMin < 60) return `last refreshed ${diffMin} min ago`;
    if (diffHour < 24) return `last refreshed ${diffHour} hr ago`;

    return `last refreshed on ${date.toLocaleDateString()}`;
  }

}
